
import { Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChatbotConfig } from '@shared/index';

@Component({
    selector: 'app-bot-word-stop',
    imports: [
    FormsModule,
    NgSelectModule
],
    templateUrl: './bot-word-stop.component.html',
    styleUrl: './bot-word-stop.component.scss'
})
export class BotWordStopComponent {
  @Input({ required: true }) public botConfig!: ChatbotConfig;
  public readonly botConfigChange = output<ChatbotConfig>();

  public saveStopWords(): void {
    this.botConfig.stopWords = this.botConfig.stopWords.map((s: string) => {
      //@ts-expect-error Passiert durch das NG-Select
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      if (s.label) s = s.label;
      return s.trim();
    }).filter(s => s.length > 0).filter((value, index, self) => self.indexOf(value) === index);
    this.botConfigChange.emit(this.botConfig);
  }
}